import React,{useEffect} from "react";


const KargoSureci = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-semibold mb-6">Kargo Süreci</h1>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">1. Sipariş Onayı</h2>
        <p>
        Siparişiniz başarıyla tamamlandıktan sonra size bir sipariş onay maili gönderilir. Sipariş bilgileriniz tarafımızca kontrol edilir ve ürünler hazırlanmak üzere ilgili birime yönlendirilir.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">2. Ürün Hazırlığı</h2>
        <p>
        Stokta bulunan ürünler genellikle aynı gün içinde ya da en geç 1-2 iş günü içinde teslim edilir. Hazırlık süresi ürün türüne, kampanya yoğunluğuna veya kişiselleştirme işlemlerine göre değişebilir.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">3. Hasarlı Ürün Bildirimi</h2>
        <p>
        Teslimat sırasında pakette herhangi bir hasar fark ederseniz, kargo görevlisine tutanak tutturmanızı rica ederiz. Bu sayede ürün değişim veya iade süreci hızlıca başlatılabilir.
        </p>
      </section>

    </div>
  );
};

export default KargoSureci;
